module.exports = __webpack_public_path__ + "static/media/Romantic-Couple.2c62cb08.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Romantic-Couple.eot
// module id = 2904
// module chunks = 71